import {createSlice} from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        items: [],
        total: 0,
    },
    reducers: {
        updateItems(state, action) {
            const {items,total} = action.payload;
            state.items = items || [];
            state.total = total || 0;
        },
        // Add item to cart
        addItemToCart(state, action) {
            const newItem = action.payload;

            if (newItem.hasOwnProperty("items")) {
                state.items = newItem.items;
                state.total = newItem.total;
                return;
            }

            const existingItem = state.items.find((item) => item.id === newItem.id);
            const qtyToAdd = newItem.quantity || 1;

            if (existingItem) {
                if (typeof newItem.stock === "number") {
                    // Stock provided , limit quantity
                    if (existingItem.quantity < newItem.stock) {
                        existingItem.quantity += qtyToAdd;
                        state.total += newItem.sellPrice * qtyToAdd;
                    }
                } else {
                    // Stock undefined , free to increase
                    existingItem.quantity += qtyToAdd;
                    state.total += newItem.sellPrice * qtyToAdd;
                }
            } else {
                // Add new item
                state.items.push({
                    ...newItem,
                    quantity: qtyToAdd,
                    productId: newItem._id
                });
                state.total += newItem.sellPrice * qtyToAdd;
            }
        },
        // Update item quantity in the cart
        updateItemQuantity(state, action) {
            const { id, change, stock } = action.payload;
            const existingItem = state.items.find((item) => item.productId === id);

            if (existingItem) {
                // If quantity is 1 and user tries to decrease, remove the item
                if (existingItem.quantity === 1 && change === -1) {
                    state.items = state.items.filter((item) => item.productId !== id); // Remove item
                    state.total -= existingItem.sellPrice; // Update total
                }
                else {
                    const newQuantity = existingItem.quantity + change;

                    if (typeof stock === "number" && !isNaN(stock)) {
                        // Stock provided , enforce stock and >= 1
                        if (newQuantity <= stock && newQuantity >= 1) {
                            existingItem.quantity = newQuantity;
                            state.total += existingItem.sellPrice * change;
                        }
                    } else {
                        // Stock undefined , free to increase
                        if (newQuantity >= 1) {
                            existingItem.quantity = newQuantity;
                            state.total += existingItem.sellPrice * change;
                        }
                    }
                }
            }
        },

        // Remove item from cart
        removeItemFromCart(state, action) {
            const id = action.payload;
            const existingItem = state.items.find((item) => item.id === id);

            if (existingItem) {
                // Remove the item from the cart
                state.items = state.items.filter((item) => item.id !== id);

                // Update the total price
                state.total -= existingItem.sellPrice * existingItem.quantity;
            }
        },

        // Clear the entire cart
        clearCart(state) {
            state.items = [];
            state.total = 0;
            state.paymentType = '';
            state.serviceType = '';
            state.paymentStatus = '';
            state.orderStatus = '';
            state.tableNo = '';
        },
    },
});

// Export actions
export const {addItemToCart, updateItemQuantity, removeItemFromCart, clearCart, updateItems} = cartSlice.actions;

// Export reducer
export default cartSlice.reducer;
